import { IWidget } from './Widget';
import { MetadataLogic } from '../metadata/MetadataLogic';
import { flatten } from 'lodash';
import { WidgetInputType } from './input/WidgetInputType';
import { IWidgetInput } from './input/WidgetInput';

type IWidgetList = IWidget & {
  input: IWidgetInput;
};

export class WidgetList {
  static assertType(widget: IWidget): asserts widget is IWidgetList {
    if (!widget.input || widget.input.type !== WidgetInputType.List) {
      throw new Error(
        'Impossibile ottenere i metadati di un Widget non di tipo lista.'
      );
    }
  }

  /**
   * Ottiene l'insieme dei metadati annidati contenuti in un Widget di
   * tipo lista
   */
  static nestedMetadata(widget: IWidget) {
    WidgetList.assertType(widget);

    const subwidgets = widget.input.subwidgets ?? [];
    const metadata = flatten(subwidgets.map(MetadataLogic.fromWidget));
    return metadata;
  }
}
